import { Timestamp as TimestampClass } from "firebase/firestore";
import { define } from "superstruct";

export type TimestampInstance = InstanceType<typeof TimestampClass>;
export const Timestamp = TimestampClass;
export const timestamp = define<TimestampInstance>(
	"timestamp",
	(t: unknown): t is TimestampInstance => t instanceof TimestampClass
);
